import styled from '@emotion/styled'

export const TooltipWrapper = styled.div`
  width: 100%;
`
